import axios from 'axios'
import { API_BASE_URL } from './constants'
import type { PortfolioFinancialsResponse } from '../types/portfolioFinancials'

/**
 * Fetch the consolidated financials roll-up for a portfolio.
 * Backend: backend/controllers/portfolioFinancialsController.js
 */
export const getPortfolioFinancials = async (
	portfolioId: string,
	token: string,
): Promise<PortfolioFinancialsResponse> => {
	const { data } = await axios.get<PortfolioFinancialsResponse>(
		`${API_BASE_URL}/portfolios/${portfolioId}/financials`,
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	)
	return data
}
